import { Injectable, OnDestroy } from '@angular/core';
import { StudentDetails, visaDetails } from 'projects/foreign-admits/src/app/f1-gtm/f1-gtm-interface/f1-gtm.interface';
import { ApiHelperService } from './api-helper.service';
import { UserIdentityService } from './user-identity.service';

@Injectable({
  providedIn: 'root'
})
export class F1GtmService implements OnDestroy {

  studentDetails: StudentDetails = {
    module: "Ancillary",
    source: "LandingPage",
    service: "InterviewPreparation",
    type: "student",
    roleId: "student",
    roleName: "student",
    services: ["InterviewPreparation"],
    servicesTaken: 1,
    usersAvailOtp: true,
    addedBy: "US Visa GTM"
  };
  partnerDetails: any;
  intervalId: any;
  link: any;
  isPrefilledDataOnBack: boolean = false;

  visaDetails: visaDetails;
  constructor(
    private apiHelper: ApiHelperService,
    private userIdentity: UserIdentityService
  ) {
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  saveStudentDetails(studentDetails: any, updateRequest?: boolean): Promise<any> {
    this.studentDetails = Object.assign(this.studentDetails, studentDetails);
    sessionStorage.setItem("studentDetails", JSON.stringify(this.studentDetails));
    delete this.studentDetails?.kycStatus
    return new Promise((res, rej) => res(this.studentDetails));
  }


  

  removeEmpty(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
      else if (typeof obj[propName] == 'object') {
        this.removeEmpty(obj[propName]);
      }
    }
    return obj
  }

  isMobileIndian(mobile: string): boolean {
    if (mobile) {
      return (mobile.startsWith("+91") && mobile.length === 13);
    }
    return true;
  }

  getVisaInformation(studentId: string) {
    return this.apiHelper.getData("visa-informations", { where: { studentId: studentId } })
  }

  resetBeforeUnload(): void {
    window.onbeforeunload = null;
  }

  // SessionStorage utility methods for avansePuid flow
  saveAvenseUserData(data: any): void {
    try {
      sessionStorage.setItem('avanse_user_data', JSON.stringify(data));
    } catch (error) {
      console.error('Error saving avanse user data to sessionStorage:', error);
    }
  }

  getAvenseUserData(): any {
    try {
      const storedData = sessionStorage.getItem('avanse_user_data');
      return storedData ? JSON.parse(storedData) : null;
    } catch (error) {
      console.error('Error retrieving avanse user data from sessionStorage:', error);
      return null;
    }
  }

  mergeAvenseUserData(newData: any): any {
    const existingData = this.getAvenseUserData() || {};
    const mergedData = { ...existingData, ...newData };
    this.saveAvenseUserData(mergedData);
    return mergedData;
  }

  clearAvenseUserData(): void {
    try {
      sessionStorage.removeItem('avanse_user_data');
    } catch (error) {
      console.error('Error clearing avanse user data from sessionStorage:', error);
    }
  }
}
